import request from '@/common/js/request';
/**
 * 获取公告/推送信息
 */
export const getData = (params) => {
    return request('/homeApi/currentUserMsgPageList',{
        params,
        method: 'get'
    })
}

/**
 * 阅读消息
 */
export const readMsg = (data) => {
    return request('/homeApi/pushMessage/read',{
        data,
        method: 'post'
    })
}

/**
 * 查询未读消息数量
 * @param params
 * @returns {Promise<any>}
 */
export const getNotReadNum = (params) => {
    return request('/homeApi/notReadNum',{
        params,
        method: 'get'
    })
}